import {useState,useEffect, useContext} from 'react';
import { useParams } from 'react-router-dom';
import { Card,CardBody,CardHeader, Container } from 'reactstrap';
import { Alert,Typography } from '@mui/material';
import { List,ListItemButton,ListItemIcon } from '@mui/material';
import { Tab,Tabs,Box } from '@mui/material';
import axios from 'axios'
import {BiRightArrow} from 'react-icons/bi'
import { CasUserContext } from '../../services/casUserContext';
import CategoriaProductos from './CategoriaProductos/CategoriaProductos';
import ProductosEsperados from './ProductosEsperados/ProductosEsperados';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Container>{children}</Container>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }
  
  export function MenuSistemas() {
    const [value, setValue] = useState<number>(0);
    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
  
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };
  
    useEffect(() => {
      const fetchData = async () =>{
        try{
             
        }catch(error){
          console.error('Error:',error);
        }
      };
      fetchData();
      },[]);
   
      return (
        <Card>
        <CardHeader>Menú</CardHeader>
        <CardBody>        
      <Box
        sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderColor: 'divider' }}
        >
          {/* <Tab label="Datos Generales" {...a11yProps(0)} /> */}
          <Tab label="Categorías de productos" {...a11yProps(0)} />
          <Tab label="Tipos de productos esperados" {...a11yProps(1)} />
          {/* <Tab label="Pertinencia" {...a11yProps(3)} />
          <Tab label="Zona de Delimitación" {...a11yProps(4)} />
          <Tab label="Financiamiento" {...a11yProps(5)} />
          <Tab label="Instituciones Colaboradores" {...a11yProps(6)} />
          <Tab label="Personal" {...a11yProps(7)} />
          <Tab label="Calificaciones" {...a11yProps(8)} />
          <Tab label="Productos Esperados" {...a11yProps(9)} />
          <Tab label="Evidencias del Proyecto" {...a11yProps(10)} />
          <Tab label="Generar Reprote" {...a11yProps(11)} />    */}
        </Tabs>
        {/* <TabPanel value={value} index={0}>
          Item uno
        </TabPanel> */}
        <TabPanel value={value} index={0}>
          <CategoriaProductos />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ProductosEsperados />
        </TabPanel>
        {/* <TabPanel value={value} index={3}>
          Item Four
        </TabPanel>
        <TabPanel value={value} index={4}>
          Item Five
        </TabPanel>
        <TabPanel value={value} index={5}>
          Item Six
        </TabPanel>
        <TabPanel value={value} index={6}>
          Item Seven
        </TabPanel> */}
      </Box>
        </CardBody>
     </Card>
    )
  }